export const SET_TGRESTORE = 'SET_TGRESTORE';
export const SET_TGRESET = 'SET_TGRESET';
export const SET_TGCALENDAR = 'SET_TGCALENDAR';
export const SET_TGTICKECTNUM = 'SET_TGTICKECTNUM';
export const SET_TGSESSION = 'SET_TGSESSION';
export const SET_TGSESSIONPICKED = 'SET_TGSESSIONPICKED';
export const SET_TGTOTALAMOUNT = 'SET_TGTOTALAMOUNT';
export const SET_SALEPRICESPREAD = 'SET_SALEPRICESPREAD';
export const SET_SHOWCROSSELL = 'SET_SHOWCROSSELL';
export const SET_TGDETAIL = 'SET_TGDETAIL';
export const SET_TGTEMPCALENDARDATA = 'SET_TGTEMPCALENDARDATA';
export const SET_ISTGDSDETAILLOADING = 'SET_ISTGDSDETAILLOADING';
export const SET_TGDDETAILFETCHFAIL = 'SET_TGDDETAILFETCHFAIL';
export const SET_ISTGDSSESSIONLOADING = 'SET_ISTGDSSESSIONLOADING';
export const SET_TGDSSESSIONFETCHFAIL = 'SET_TGDSSESSIONFETCHFAIL';
export const SET_TGNOWLIST = 'SET_TGNOWLIST';
export const SET_TGNOWLISTDATA = 'SET_TGNOWLISTDATA';
export const SET_TGMINFOSHOW = 'SET_TGMINFOSHOW';
export const SET_TGCALENDARERR = 'SET_TGCALENDARERR';
export const SET_TGSESSIONERR = 'SET_TGSESSIONERR';
export const SET_TGTICKETErr = 'SET_TGTICKETErr';
export const SET_TGSCROLLTO = 'SET_TGSCROLLTO';
export const SET_TGSUBMITWATCHER = 'SET_TGSUBMITWATCHER';
export const SET_ISTGSUBMITSUCCESS = 'SET_ISTGSUBMITSUCCESS';
export const SET_TGFINALABLEDATES = 'SET_TGFINALABLEDATES';
export const SET_TGSUBMITERRMSG = 'SET_TGSUBMITERRMSG';
